exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-close[data-v-1244a90e]{background-color:red;opacity:.5;outline:none;border:0;width:25px;height:25px;color:#fff;font-size:1.35rem;line-height:1;position:absolute;top:50%;right:-12.5px;transform:translateY(-50%)}.btn-close[data-v-1244a90e]:hover{opacity:.8}", ""]);

// exports
